import React, { createContext, useContext, useMemo, useState, type ReactNode } from 'react'

type MenuBasketCtaContextValue = {
  labelHTML?: string
  setLabelHTML: (labelHTML?: string) => void
}

const MenuBasketCtaContext = createContext<MenuBasketCtaContextValue>({
  setLabelHTML: () => {},
})
MenuBasketCtaContext.displayName = 'MenuBasketCtaContext'

/**
 * Carries the `basketCta` label from the menu xAPI response, which is fetched inside the menu
 * page, to the basket, which is rendered alongside the page rather than inside it.
 */
export const MenuBasketCtaProvider = ({ children }: { children: ReactNode }) => {
  const [labelHTML, setLabelHTML] = useState<string>()
  const value = useMemo(() => ({ labelHTML, setLabelHTML }), [labelHTML])

  return <MenuBasketCtaContext.Provider value={value}>{children}</MenuBasketCtaContext.Provider>
}

export const useMenuBasketCta = (): MenuBasketCtaContextValue => useContext(MenuBasketCtaContext)
